<template>
  <v-layout wrap>
    <v-form ref="form" v-model="formIsValid">
      <v-select :items="templateSelectionItems" v-model="templateId.value" label="Static Content Template" :rules="templateId.rules" />
      <v-divider />
      <v-flex xs12>
        <StaticContentFormInfo :value="selectedTemplateName" />
      </v-flex>
      <v-text-field v-model="itemData.value[itemDataField]" v-for="(itemDataField, i) in itemDataFields" :key="`input-${itemDataField}-${i}`" :label="capitalize(itemDataField)" :rules="formValidationRuleByName(itemDataField)" />
    </v-form>
  </v-layout>
</template>

<script>
  import {
    createNamespacedHelpers,
  } from 'vuex'
  const landingPageStaticContent = createNamespacedHelpers('landingPageStaticContent')
  const app = createNamespacedHelpers('app')

  import { capitalize } from '@/helpers/strings'
  import StaticContentFormInfo from '@/components/LandingPageStaticContent/Form/StaticContentFormInfo'

  const urlRegex = /^(https?:\/\/)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)*$/
  const urlValidationRule = x => {
    return urlRegex.test(x) || 'Url did not pass validation, please check again.'
  }
  export default {
    components: {
      StaticContentFormInfo,
    },
    props: {
      tenantName: {
        type: String,
        default: '',
      },
      addForm: {
        type: Boolean,
        default: false,
      },
      value: {
        type: Object,
        default: () => ({}),
      },
      isValid: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        templateId: { value: '', rules: [v => !!v || 'Required'] },
        itemData: { value: {}, rules: [] },
        formIsValid: false,
      }
    },
    computed: {
      ...landingPageStaticContent.mapState(['templates']),
      ...landingPageStaticContent.mapGetters(['nextOrdinal']),
      templateSelectionItems() {
        return this.templates.data.map(x => ({ text: x.DisplayName, value: x.Id }))
      },
      itemDataFields() {
        return Object.keys(this.itemData.value)
      },
      submitItem() {
        let payload = {
          Id: this.value.Id,
          TemplateId: this.templateId.value,
          ItemData: JSON.stringify(this.itemData.value),
          Ordinal: this.value.Ordinal || this.nextOrdinal,
        }
        return payload
      },
      selectedTemplateName() {
        const selected = this.templateSelectionItems.find(x => x.value == this.templateId.value)
        return selected ? selected.text : ''
      },
    },
    watch: {
      value() {
        this.updateForm()
      },
      formIsValid(val) {
        this.$emit('update:isValid', val)
      },
      templateId: {
        handler() {
          this.updateItemDataWithTemplateId(this.templateId.value)
        },
        deep: true,
      },
    },
    methods: {
      capitalize,
      ...app.mapActions(['setSnackbar']),
      ...landingPageStaticContent.mapActions([
        'getStaticContentTemplates',
        'addStaticContentItem',
        'updateStaticContentItem',
      ]),

      updateForm() {
        if (this.value == null || this.value.Id == null) {
          return
        }
        this.templateId.value = this.value.TemplateId
        this.itemData.value = JSON.parse(this.value.ItemData)
      },
      resetForm() {
        this.$refs.form.resetValidation()
        this.templateId.value = ''
        this.itemData.value = {}
      },
      updateItemDataWithTemplateId(templateId) {
        if (this.value && this.value.TemplateId && templateId == this.value.TemplateId) {
          this.$set(this.itemData, 'value', JSON.parse(this.value.ItemData))
          return
        }
        const template = this.templates.data.find(x => x.Id == templateId)
        if (template == null) {
          return
        }
        this.$set(this.itemData, 'value', JSON.parse(template.TemplateData))
      },
      formValidationRuleByName(fieldName) {
        if (fieldName && fieldName.toLowerCase() == 'url') {
          return [urlValidationRule]
        }
        return []
      },
      async submit() {
        if (this.addForm) {
          await this.submitAddItem()
        } else {
          await this.submitUpdateItem()
        }
      },
      async submitAddItem() {
        try {
          await this.addStaticContentItem({ data: this.submitItem, tenantName: this.tenantName })
          this.setSnackbar({
            text: 'Static content item saved successfully',
            color: 'success',
            icon: 'done',
          })
        } catch (ex) {
          this.setSnackbar({
            text: `Failed to save static item: ${ex}`,
            color: 'error',
            icon: 'error',
          })
          console.error(ex)
          throw ex
        }
      },
      async submitUpdateItem() {
        try {
          await this.updateStaticContentItem({ data: this.submitItem, tenantName: this.tenantName })
          this.setSnackbar({
            text: 'Static content item updated successfully',
            color: 'success',
            icon: 'done',
          })
        } catch (ex) {
          this.setSnackbar({
            text: `Failed to update static item: ${ex}`,
            color: 'error',
            icon: 'error',
          })
          console.error(ex)
          throw ex
        }
      },

    },
    async mounted() {
      this.updateForm()
      try {
        await this.getStaticContentTemplates({ forced: false })
      } catch (ex) {
        this.setSnackbar({
          text: `Failed to load static content templates from the server, please refresh the page again. ${ex}`,
          color: 'error',
          icon: 'error',
        })
        console.error(ex)
      }
    },
  }
</script>